import { ChangeDetectionStrategy, Component } from '@angular/core';
import { BaseDatatableCellComponent } from 'app/shared/components/table/components/table/base-datatable-cell.component';

@Component({
  selector: 'app-status-indicator-cell',
  template: `
    <div class="flex items-center">
      <span
        class="w-2 h-2 mr-2 rounded-full"
        [style.background-color]="dotColor"
      >
      </span>
      <span>{{ label }}</span>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StatusIndicatorCellComponent extends BaseDatatableCellComponent {
  get label() {
    return this.colDef().custonConfig?.['getLabel']?.(this.rowData());
  }
  get dotColor() {
    return this.colDef().custonConfig?.['getDotColor']?.(this.rowData());
  }
}
